// footer-loader.js - Loads shared footer HTML into pages

(function() {
  // Determine the correct path to footer.html based on current page location
  function getFooterPath() {
    const path = window.location.pathname;
    
    // Count directory depth by checking how many levels deep we are
    if (path.includes('/swapper/swap/') || path.includes('/swapper/autoswap/')) {
      // Two levels deep: /swapper/swap/ or /swapper/autoswap/
      return "/footer/footer";
    } else if (path.includes('/swapper/')) {
      // One level deep: /swapper/
      return "/footer/footer";
    }
    
    // Root level
    return "/footer/footer";
  }
  
  // Load footer when DOM is ready
  function loadFooter() {
    const footerContainer = document.getElementById('footer-container');
    
    if (!footerContainer) {
      console.warn('Footer container not found');
      return;
    }
    
    const footerPath = getFooterPath();
    
    fetch(footerPath)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Failed to load footer: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        footerContainer.innerHTML = html;
      })
      .catch(error => {
        console.error('Error loading footer:', error);
        // Fallback: insert basic footer
        footerContainer.innerHTML = '<footer class="app-footer"><div class="footer-content"><p>© 2026 AquaVaults</p></div></footer>';
      });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadFooter);
  } else {
    loadFooter();
  }
})();